import React from 'react';

import { CFMUpdateState } from '../types';
import StartStep from '../components/StartStep';
import ClinicStep from '../components/ClinicStep';
import ClinicBillingStep from '../components/ClinicBillingStep';
import ProfessionalStep from '../components/ProfessionalStep';
import { DoneStep } from '../components/DoneStep';

export const useCFMSteps = (onClose: () => void): CFMUpdateState['steps'] => ({
  start: <StartStep onClose={onClose} />,
  clinic: <ClinicStep />,
  clinicBilling: <ClinicBillingStep />,
  professional: <ProfessionalStep />,
  done: <DoneStep onClose={onClose} />,
});
